export enum TenderStatesEnum {
  Active = 'ACTIVE',
  In_The_Future = 'IN_THE_FUTURE',
  Expired = 'EXPIRED',
}
